import store from '@/store';

export default class ClientChatInactiveEvent {
  constructor(event) {
    store.dispatch('jobs/alterClientStatusChat', {
      from: event.from,
      newStatus: 'inactive',
    });
  }
}
